import IGuid = System.IGuid;

export interface INFertilizationOverviewGridDetailsItem {
  Id: IGuid;
  PlanBookId: IGuid;
  FieldId: IGuid;
  Status: number;
  StatusClass: string | null;
  StatusDesc: string | null;
  ProductName: string;
  ProductId: number | null;
  CropKey: number | null;
  WorkArea: number;
  Administration: string;
  Application: number;
  EC: number;
  Date: Date;
  MidnightDate: Date;
  ProductTotal: number | null;
  ProductTotalUnit: string;
  FertilizerEfficiency: number | null;
  AlreadyApplied: number | null;
  Absorption: IGridDetailsItemContentRange | null;
  Fertilization: IGridDetailsItemContentRange | null;
}

export interface IGridDetailsItemContentRange {
  Min: number;
  Max: number;
  Avg: number;
}

export enum NFertilizationOverviewMassEditAction {
  Edit = 0
}
